import { fetchShoppingSceneAemContent } from "@/services/aem";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getScenePlusData = createAsyncThunk(
  "/aem/getShoppingListSceneData",
  async () => {
    // const res = await fetchShoppingSceneAemContent();
    // return res;
  }
);
